import React from "react";
import * as XLSX from "xlsx";

const ExportExcel = ({ data }) => {
  const exportToExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Convert data to a worksheet
    const ws = XLSX.utils.json_to_sheet(data);

    // Styling the header row
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "4CAF50" } }, // Green color for header background
      alignment: { horizontal: "center" },
    };

    // Applying style to the header row
    const range = XLSX.utils.decode_range(ws['!ref']); // Get the range of data
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = { r: 0, c: col }; // First row (header)
      const cell = ws[XLSX.utils.encode_cell(cellAddress)];
      if (cell) {
        cell.s = headerStyle; // Apply styles
      }
    }

    // Setting custom column widths
    const columnWidths = [
      { wch: 20 }, // Category column width
      { wch: 30 }, // Item Name column width
      { wch: 15 }, // Image column width
      { wch: 40 }, // Specification column width
      { wch: 10 }, // Price column width
      { wch: 15 }, // Actions column width
    ];

    ws['!cols'] = columnWidths;

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Categories");

    // Write the Excel file and trigger download
    XLSX.writeFile(wb, "categories.xlsx");
  };

  return (
    <button
      onClick={exportToExcel}
      className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-700"
    >
      Export to Excel
    </button>
  );
};

export default ExportExcel;
